import { useEffect, useState } from "react";
import { useAccessibility } from "@rosette/web_components/src/accessibility/AccessibilityContext.js";
import { BreatheScheduler } from "@/components/generic/sheen/BreatheScheduler.js";


// Matches --animate-quickplay-breathe in theme.css.
export const BREATHE_DURATION_MS = 1750;


/**
 * Whether a breathe is running now, on the BreatheScheduler's timing,
 * kept clear of the sheens that isClearFor (from useSheen) reports.
 * Never true when the user prefers reduced motion.
 */
export function useBreathe(isClearFor: (durationMs: number) => boolean): boolean {
    const reducedMotion = useAccessibility().useReducedMotion();
    const [breathing, setBreathing] = useState(false);

    // This begins on the same render as useSheen's scheduler, so the two
    // count from the same moment.
    useEffect(() => {
        if (reducedMotion)
            return;

        const scheduler = new BreatheScheduler(
            BREATHE_DURATION_MS,
            () => setBreathing(true),
            () => setBreathing(false),
            isClearFor,
        );
        scheduler.begin();
        return () => {
            scheduler.stop();
            setBreathing(false);
        };
    }, [reducedMotion, isClearFor]);

    return breathing;
}
